/* SUNKIS cookie notice (sunkis-main-pdp cookies.js design).
   Shows the glass card until the visitor chooses, passes Accept / Reject to Shopify's Customer Privacy
   API (so Shopify analytics, pixels and customer-event integrations follow the choice) and remembers it.
   Buttons with data-consent elsewhere (the privacy page's "Manage cookie preferences") do the same.
   Fires window "sunkis:consent" with the choice, like the original. */
(function () {
  if (window.__sunkisConsentInit) return;
  window.__sunkisConsentInit = true;

  var KEY = 'sunkis-consent';
  var CHOICES = {
    accepted: { analytics: true, marketing: true, preferences: true },
    rejected: { analytics: false, marketing: false, preferences: false }
  };

  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  /* Shopify Customer Privacy API, loaded once on demand. cb(api or null) */
  var waiting = null;
  function privacyApi(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy && S.customerPrivacy.setTrackingConsent) { cb(S.customerPrivacy); return; }
    if (!S || typeof S.loadFeatures !== 'function') { cb(null); return; }
    if (waiting) { waiting.push(cb); return; }
    waiting = [cb];
    var finish = function () {
      var list = waiting || [];
      waiting = null;
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      list.forEach(function (f) { f(cp && cp.setTrackingConsent ? cp : null); });
    };
    var load = function (version, fallback) {
      try {
        S.loadFeatures([{ name: 'consent-tracking-api', version: version }], function (err) {
          if (err && fallback) load(fallback, null); else finish();
        });
      } catch (e) { finish(); }
    };
    load('0.2', '0.1');
  }

  function decided(cp) {
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
    try {
      var c = cp.currentVisitorConsent() || {};
      return c.analytics === 'yes' || c.analytics === 'no' || c.marketing === 'yes' || c.marketing === 'no';
    } catch (e) { return false; }
  }

  function apply(choice) {
    remember(choice);
    var signal = CHOICES[choice];
    if (signal) {
      privacyApi(function (cp) {
        if (!cp) return;
        try { cp.setTrackingConsent(signal, function () {}); } catch (e) {}
      });
    }
    try { window.dispatchEvent(new CustomEvent('sunkis:consent', { detail: choice })); } catch (e) {}
  }

  /* ---------- the notice ---------- */
  var banner = document.querySelector('[data-sk-consent]');
  var root = document.documentElement;

  function show() {
    if (!banner || !banner.hidden) return;
    banner.hidden = false;
    root.classList.add('sk-cc-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { banner.classList.add('show'); }); });
  }
  function hide() {
    if (!banner || banner.hidden) return;
    banner.classList.remove('show');
    root.classList.remove('sk-cc-open');
    setTimeout(function () { banner.hidden = true; }, 450);
  }

  if (banner) {
    banner.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sk-consent-choice]');
      if (!b) return;
      apply(b.getAttribute('data-sk-consent-choice'));
      hide();
    });

    if (!stored()) {
      var settled = false;
      var decide = function (cp) {
        if (settled) return;
        settled = true;
        if (stored() || decided(cp)) return;
        if (document.querySelector('#shopify-pc__banner')) return; /* Shopify's own banner is showing */
        show();
      };
      privacyApi(decide);
      setTimeout(function () { decide(null); }, 2500);
    }
  }

  /* ---------- "Manage cookie preferences" buttons (privacy page) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-consent]'), function (b) {
    b.addEventListener('click', function () {
      apply(b.getAttribute('data-consent'));
      hide();
      if (b.__skLabel == null) b.__skLabel = b.textContent;
      b.textContent = b.getAttribute('data-saved-label') || 'Saved';
      clearTimeout(b.__skT);
      b.__skT = setTimeout(function () { b.textContent = b.__skLabel; }, 1600);
    });
  });
})();
